module.exports = __webpack_public_path__ + "img/Urban space cannot be fragmented into commodities.974c9511.jpg";